export function toSnakeCase(text: string): string {
  return text
    .replace(/([a-z])([A-Z])/g, "$1_$2") // Add underscore between camelCase words
    .replace(/\s+/g, "_") // Replace spaces with underscores
    .toLowerCase(); // Convert to lowercase
}

export const snakeToTitleCase = (s: string) => {
  try {
    return s
      .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
      .replace(/[-_]+(.)/g, (_, c) => " " + c.toUpperCase());
  } catch (error) {
    console.log("error converting snake to title case", error);
    return s;
  }
};

export const cleanStringExcelSheet = (string: string) => {
  try {
    return string.replace(/[\[\]:\/\\\?\*]/gi, ""); //eslint-disable-line
  } catch (error) {
    console.log("error cleaning string for excel sheet", error);
    return "";
  }
};

export function capitalizeFirstLetter(string: string) {
  if (!string) return ""; // Handle empty or undefined strings
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const likeMatch = (target: string, searchQuery: string) => {
  // searchQuery: The value you're trying to find - target: The string you're searching in
  try {
    return new RegExp(searchQuery, "i").test(target);
  } catch (error) {
    console.log("error in likeMatch:", error);
    return false;
  }
};

export const clearMatch = (target: string, searchQuery: string) => {
  // Take a str and a pattern
  // Turn the pattern into an array of patterns
  // Match the str against the patterns
  // E.g. str: "age became a fan", pattern: ["fan, "age", "became"] should return true
  try {
    const searchQueryWordsArray = searchQuery
      // .split(/,| |-/)
      .split(/,| /) // Allow for dashes in search query
      .map(
        (word) => new RegExp(cleanSymbolsFromString(word.toLowerCase()), "gi")
      );

    const string = cleanSymbolsFromString(target).toLowerCase();

    const isMatch = searchQueryWordsArray.every((word) => word.test(string));

    return isMatch;
  } catch (err) {
    console.log(err);
    return false;
  }
};
export const cleanSymbolsFromString = (str: string) => {
  try {
    return str.replace(/[\W_]+/g, " ");
  } catch (error) {
    console.log(error);
    return str;
  }
};
